<template>
	<div @click.self="this.popoverMc = false;">
		<div class="center" @click.self="this.popoverMc = false;">
			<div class="header flexcenter">
				<Icon icon="reload-light" :class="this.modelSpinners.baseModel ? 'spinner' : ''" @click="getBaseModel()" />
				<h3>Välj mc </h3>
			</div>
			<hr />
			<div class="flexcenter" style="align-items:stretch;">
				<div style="background:var(--grey-2);padding:10px;width:50%;">
					<b>Vald mc</b><br />
					{{ this.brand ? this.brand.name : 'Inget brand' }} /
					{{ this.brand && this.mc ? this.mc.modelName : 'Ingen mc-modell' }} /
					{{ this.brand && this.mc && this.year ? this.year.year : 'Inget år ' }}
					<br />
					Antal produkter: {{ productCountMc }}
				</div>

			</div>
			<hr />

			<div style="background:var(--grey-2);padding:10px;" class="flexcenter" title="Välj mc-märke och mc-modell">


				<select v-if="mcTree" v-model="this.brand" @change="this.setupScroll()">
					<option :value="null">Välj märke</option>
					<option v-for="(brand) in mcTree" :key="brand.id" :value="brand">{{ brand.name }}</option>
				</select>

				<select v-if="mcTree" v-model="mc" @change="this.setupScroll()">
					<option :value="null">Välj mc</option>
					<option v-for="mc in this.brand && this.brand.modelList" :key="mc.mcId" :value="mc">{{ mc.modelName }}
					</option>

				</select>

				<select v-if="mcTree" v-model="year" @change="this.setupScroll()">
					<option :value="null">Välj år</option>
					<option v-for="year in this.mc && this.mc.yearList.filter(year => year != null).sort((a, b) => b.year - a.year)" :key="year.year"
						:value="year">{{
						year.year }}
					</option>

				</select>

			</div>

			<hr />

			<div class="flexcenter" @click.self="this.popoverMc = false;">

				<div style="background:var(--grey-2);border:1px solid var(--grey-4);border-radius:5px;">
					<div style="padding:10px;" @click="this.popoverMc = !this.popoverMc">
						<div class="flexcenter link">
							<Icon v-if="this.brand" fileName="w3_circle_close_dark" style="width:16px;height:16px;"
								@click.stop="this.brand = null; this.popoverMc = false;" />

							<b style="flex-grow:1;">{{ this.brand ? this.brand.name : 'MC' }}</b>



						</div>
						<div class="flexcenter">
							<div> {{ this.mc ? this.mc.modelName : 'Välj mc-modell' }}</div>



							<div v-if="this.mc"
								style="background:var(--grey-4);padding:2px 5px 2px 5px;border-radius:3px;margin-left:5px;"> {{
								this.year ?
								this.year.year :
								'Alla årtal' }}
							</div>

							<Icon :fileName="this.popoverMc ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark'"
								style="width:12px;height:12px;margin-left:10px;" />

						</div>
					</div>
					<div v-show="this.popoverMc"
						style="position:absolute;background:var(--grey-3);width:400px;height:400px;padding:10px;filter: drop-shadow(0px 2px 10px #777777);">

						<div style="height:100%;">



							<div v-if="this.mcTree" style="height:100%;">

								<!-- lista märken -->
								<div v-show="!this.brand" style="height:100%;">

									<!-- sök mc-märke-->
									<div v-if="1 == 2" style="height:50px;">

										<div class="form textField" :title="'filter: ' + this.filterBrand" style="height:30px;padding:0px;">
											<input type="text" placeholder="Value..." v-model="filterBrand" />
											<img src="@/assets/button_close_dark.png" @click="this.filterBrand = ''"
												style="height:20px;width:20px;margin-right:5px;" />
										</div>


									</div>

									<div class="flexcenter" style="padding-bottom:5px;">
										<h3>Välj mc</h3>
										<b style="flex-grow:1;">&nbsp;</b>
										<img src="@/assets/button_close_dark.png" @click="this.popoverMc = false;"
											style="height:20px;width:20px;margin-right:5px;" />

									</div>



									<!-- lista alla mc-->

									<div ref="brandList" title="brandList" style="overflow:scroll;max-height: calc(100% - 130px);">

										<div v-for="(brand) in filterBrandList(mcTree)" :key="brand.id" ref="brands"
											:id="'brand-' + brand.id" :title="'brand-' + brand.id"
											style="background:var(--grey-2);margin-bottom:5px;padding:0px 0px 0px 0px;" class="link">

											<div style="background:var(--grey-4);padding:5px;border-radius: 0px;position:sticky;top:0px;"
												@click=" this.brand && this.brand.id == brand.id ? this.brand = null : this.brand = brand;">
												<b style="" :title="brand.id">{{ brand.name }}</b>
											</div>
										</div>

									</div>


									<!-- lista med logos -->
									<div
										style="height:120px;width:100%;background:transparent;display:flex;gap:5px;flex-wrap:wrap;margin-top:10px;">


										<div class="brandBox" @click="selectBrand(2044);">
											<img src="https://www.boove.se/static/media/aprilia.f039aa6c.png" />
										</div>

										<div class="brandBox" @click="selectBrand(2229);">
											<img src="https://www.boove.se/static/media/bmw.54b060da.png" />
										</div>

										<div class="brandBox" @click="selectBrand(2550);">
											<img src="https://www.boove.se/static/media/ducati.68547372.png" />
										</div>

										<div class=" brandBox" @click="selectBrand(5241);">
											<img src="https://www.boove.se/static/media/hd.20b1ce93.png" />
										</div>

										<div class="brandBox" @click="selectBrand(4424);">
											<img src="https://www.boove.se/static/media/honda.48add75d.png" />
										</div>

										<div class="brandBox" @click="selectBrand(3751);">
											<img src="https://www.boove.se/static/media/huskvarna.b5492f38.png" />
										</div>

										<div class="brandBox" @click="selectBrand(4241);">
											<img src="https://www.boove.se/static/media/kawasaki.9b2c5f93.png" />
										</div>

										<div class=" brandBox" @click="selectBrand(4101);">
											<img src="https://www.boove.se/static/media/ktm.25473821.png" />
										</div>

										<div class="brandBox" @click="selectBrand(5446);">
											<img src="https://www.boove.se/static/media/mv-agusta.2b5af30c.png" />
										</div>

										<div class="brandBox" @click="selectBrand(4723);">
											<img src="https://www.boove.se/static/media/suzuki.5ab4584b.png" />
										</div>

										<div class="brandBox" @click="selectBrand(5264);">
											<img src="https://www.boove.se/static/media/triumph.37066cbd.png" />
										</div>

										<div class=" brandBox" @click="selectBrand(4931);">
											<img src="https://www.boove.se/static/media/yamaha.e7e8bfc4.png" />
										</div>



									</div>

								</div>


								<!-- om vi har ett märke-->
								<div v-show="this.brand" style="height:100%;">
									<div v-if="this.brand" style="background:var(--grey-4);padding:5px;border-radius: 5px;"
										class="flexcenter" @click.self="this.popoverMc = false;">

										<Icon fileName="w3_chevron_left_dark" style="width:10px;height:16px;margin-right:5px;"
											@click="this.brand = null;" />
										<h3>{{ this.brand.name }}</h3>

										<b style="flex-grow:1;">&nbsp;</b>

										<img src="@/assets/w3_button_close_dark.png" @click="this.popoverMc = false;"
											style="height:20px;width:20px;margin-right:0px;" class="link" />


									</div>

									<div v-if="this.brand" style="height:30px;margin-top:10px;margin-bottom:10px;">

										<div class="form textField" :title="'filter: ' + this.filterMc" style="height:30px;padding:0px;">
											<input type="text" :placeholder="'Sök ' + this.brand.name + ' modeller'" v-model="filterMc" />
											<img v-if="1==2" src="@/assets/w3_button_close_light.png" @click="this.filterMc = ''"
												style="height:20px;width:20px;margin-right:5px;" />
										</div>


									</div>

									<div ref="mcList" style="overflow:scroll;max-height: calc(100% - 90px);">

										<!-- mc list för valt märke -->
										<div v-for="mc in this.brand && filterMcList(this.brand.modelList)" :key="mc.mcId" ref="mcs"
											:id="'mc-' + mc.mcId"
											style="background:var(--grey-4);padding:5px;margin-top:5px;border-radius:5px;"
											@click="this.mc = mc">
											<div class="link">
												{{ mc.modelName }}
											</div>


											<!-- årsmodeller -->
											<div v-if="this.mc && this.mc.mcId == mc.mcId" style="margin-top:5px;">
												<div style="display:flex;justify-content:start;gap:5px 3px; flex-wrap: wrap;">

													<div
														style="padding:3px;border-radius:3px;background:var(--grey-2);border:1px solid var(--grey-2);"
														:style="!this.year ? 'border:1px solid var(--grey-6);' : ''" class="link"
														@click="this.popoverMc = false">
														Alla år</div>


													<div v-for="year in this.mc && this.mc.yearList" :key="year.year"
														style="padding:3px;border-radius:3px;background:var(--grey-2);border:1px solid var(--grey-2);"
														class="link"
														:style="this.year && this.year.year == year.year ? 'border:1px solid var(--grey-6);' : ''"
														@click="this.year = year; this.popoverMc = false">
														{{ year.year }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr/>

			<SelectMcWrapper />

			<hr />
			<div v-if="!this">
				<h3 style="margin-top:40px;">Välj kategori </h3>

				<div style="background:var(--grey-2);padding:10px;width:50%;">
					<b>Vald kategori</b><br />
					{{ this.category ? this.category.name : 'Ingen kategori vald (name)' }}<br />
					{{ this.category ? this.category.path : 'Ingen kategori vald (path)' }}<br />
					{{ this.category && 1 == 2 ? this.category.pathIdList : '' }}
					<br />
					Antal produkter: {{ productCountCategory }}
				</div>

				<hr />

				<div style="background:var(--grey-2);padding:10px;">
					<b>Kategori-lista</b> (som man kommer kunna söka i)<br />
					<select v-model="selectedCategoryInList" @change="changedX()">
						<option :value="null">Välj kategori</option>
						<option v-for="category in categoryList" :key="category.categoryId" :value="category">{{ category.path }}
						</option>
					</select>
				</div>
				<hr />
				<div style="background:var(--grey-2);padding:10px;">

					<b>Kategori breadcrumbs</b>
					<div class="flexcenter" style="background: var(--grey-3);align-items:start;">

						<div v-for="categoryX in this.categoryPath" :key="categoryX.categoryId"
							style="padding:10px;margin-right:5px;">

							<div style="background:var(--grey-4);padding:5px;margin-bottom:5px;border-radius: 5px;;">/{{
								categoryX.name
								}}</div>
							<select v-if="categoryX.categoryList && categoryX.categoryList.length > 0" v-model="this.category">
								<option :value="childCategory" v-for="childCategory in categoryX.categoryList"
									:key="childCategory.categoryId">
									{{ childCategory.name }}
								</option>
							</select>


						</div>

					</div>


				</div>

				<hr />
				<div style="background:var(--white);padding:0px;">

					<b>Kategori breadcrumbs 2</b>
					<div class="flexcenter breadcrumbs" style="background: var(--white);align-items:start;">

						<div v-for="categoryX in this.categoryPath" :key="categoryX.categoryId"
							style="padding:0px;margin-right:5px;">

							<!-- kategori namn-->
							<div class="flexcenter link category"
								style="background:var(--grey-2);padding:5px;margin-bottom:0px;border-radius: 5px;"
								@click="this.showCategoryId != categoryX.categoryId ? this.showCategoryId = categoryX.categoryId : this.showCategoryId = null">
								<div>
									/{{
									categoryX.name
									}}</div>

								<Icon v-if="categoryX.categoryList != null"
									:fileName="this.showCategoryId == categoryX.categoryId ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark'"
									style="width:12px;height:12px;margin-left:10px;" />
							</div>
							<!-- lista av underkategorier -->
							<div
								v-if="categoryX.categoryList && categoryX.categoryList.length > 0 && this.showCategoryId == categoryX.categoryId"
								style="position: absolute;background:var(--grey-3);padding:5px;min-width:250px;max-height:200px;overflow-y:scroll;
								filter: drop-shadow(0px 2px 10px #777777);overscroll-behavior: contain;">

								<!-- varje underkategori-->
								<div :value="childCategory" v-for="childCategory in categoryX.categoryList"
									:key="childCategory.categoryId"
									@click="selectCategory(childCategory.categoryId); this.showCategoryId = null"
									style="padding:5px;margin-bottom:5px;background:var(--grey-1);"
									class="flexcenter link childCategoryList" :title="'Visa produkter i kategori: ' + childCategory.name">

									<div v-if="childCategory.categoryList" class="flexcenter childCategory" style="width:100%;">
										{{ childCategory.name }}
										<b style="flex-grow:1;">&nbsp;</b>
										<div style="width:30px;height:20px;justify-content:end;" class="flexcenter categoryArrow"
											:title="'Visa underkategorier till: ' + childCategory.name" @click.stop="selectCategory(childCategory.categoryId); this.showCategoryId =
												childCategory.categoryId">

											<Icon fileName="w3_chevron_right_black" style="width:8px;height:12px;margin-right:5px;"
												:title="'Visa underkategorier till: ' + childCategory.name" />

										</div>

									</div>

									<div v-if="!childCategory.categoryList" class="flexcenter" style="width:100%;">
										{{ childCategory.name }}
										<b style="flex-grow:1;">&nbsp;</b>
										<div class="badge">
											{{ childCategory.productList.length }}
										</div>

									</div>
								</div>
							</div>

						</div>

					</div>


				</div>

				<hr />
				<div class="flexcenter">
					<div>
						<!-- välja kategori-knapp -->
						<div style="background:var(--grey-2);border:1px solid var(--grey-4);border-radius:5px;padding:10px;"
							@click="this.popoverCategory = !this.popoverCategory">
							<div class="flexcenter link">

								<img src="@/assets/button_close_dark.png" v-if="this.category" @click="this.category = null"
									style="height:16px;width:16px;" />

								<b>{{ this.category ? this.categoryPathLabel(this.categoryPath) : 'Kategorier' }} </b>
							</div>
							<div class="flexcenter">
								<div>{{ this.category ? this.category.name : 'Välj kategori' }}</div>
								<b style="flex-grow:1;">&nbsp;</b>
								<Icon :fileName="this.popoverCategory ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark'"
									style="width:12px;height:12px;margin-left:10px;" />
							</div>
						</div> {{ this.filterCategory }} -- {{ this.isFilterCategoryEmpty }}

						<!-- kategori popover -->
						<div v-show="this.popoverCategory"
							style="position:absolute;background:var(--grey-3);width:400px;height:400px;padding:10px;filter: drop-shadow(0px 2px 10px #777777);overscroll-behavior: contain;">



							<!-- lista under-kategorier i vald kategori-->
							<div style="height:100%;">

								<div class="flexcenter" v-if="this.isFilterCategoryEmpty">

									<Icon v-if="this.category" fileName="w3_chevron_left_dark"
										style="width:10px;height:16px;margin-right:5px;"
										@click="selectCategory(this.categoryPopover.parent)" />

									<h3>{{ this.categoryPopover.name }}</h3>
									<b style="flex-grow:1">&nbsp;</b>
									<img src="@/assets/button_close_dark.png" class="link" @click="this.popoverCategory = false;"
										style="height:20px;width:20px;margin-right:5px;" />
								</div>

								<div v-if="!this.isFilterCategoryEmpty">
									<h3>Kategori xx</h3>
								</div>

								<!-- fritextsökning input -->

								<div v-if="!this.category || !this.isFilterCategoryEmpty" class="form textField"
									:title="'filter: ' + this.filterCategory"
									style="height:30px;padding:0px;margin-top:5px;margin-bottom:10px;">
									<input type="text" placeholder="Sök kategori..." v-model="this.filterCategory" />
									<img src="@/assets/w3_button_close_light.png" v-if="!this.isFilterCategoryEmpty"
										@click="this.filterCategory = ''" style="height:20px;width:20px;margin-right:5px;" />
								</div>

								<!-- fritextsökning resultat -->
								<div v-if="!this.isFilterCategoryEmpty"
									style="height:calc(100% - 0px);padding-top:5px;padding-bottom:5px;">



									<!-- sökresultat -->
									<div style="overflow:scroll;max-height:calc(100% - 80px);">



										<div v-for="(category, index) in filteredCategoryList" :key="index"
											style="background:var(--grey-1);padding:5px;" @click="this.selectCategory(category.categoryId)">
											<b>{{ category.name }}</b><br />
											<span style="color:grey;margin-left:0px;font-size:85%;">{{ category.path }}</span>


										</div>





									</div>

								</div>

								<!-- lista kategori-träd utan sökning, dra av för höjden på sökfältet -->
								<div v-if="this.isFilterCategoryEmpty" style="overflow:scroll;"
									:style=" this.category ? 'max-height:calc(100% - 50px);' : 'max-height:calc(100% - 100px);' "
									ref="categoryList">

									<div v-for="category in this.categoryPopover.categoryList" :key="category.categoryId"
										:style="this.category && this.category.categoryId == category.categoryId ? 'background:var(--grey-5);' : 'background:var(--grey-1);'"
										style="padding:5px;margin-bottom:5px;" class="link">

										<!-- klickbar kategori, wrapper -->
										<div style="" ref="categoryListRef" :id="'category-' + category.categoryId ">

											<div class="flexcenter" v-if="category.categoryList" style="align-items: stretch;">
												<div @click="this.category = category; this.popoverCategory = false;" style="flex-grow:1;">{{
													category.name }} </div>


												<div class="flexcenter link" style="padding-left:20px;" @click="this.category = category;">
													<Icon fileName="w3_chevron_right_dark"
														style="width:8px;height:12px;margin-right:5px;margin-left:10px;" />
												</div>

											</div>

											<div class="flexcenter" v-if="!category.categoryList"
												@click="this.category = category; this.popoverCategory = false;">
												{{ category.name }}
												<b style="flex-grow:1;">&nbsp;</b>

												{{ category.productList.length }}
											</div>
										</div>

									</div>
								</div>
							</div>


							<div v-if="!this.category && false" style="overflow:scroll;max-height:calc(100% - 100px);">
								<div style="padding:5px;margin-bottom:10px;">
									<b>Lista huvud-kategorier</b>
								</div>
								<div v-for="category in this.categoryPopover.categoryList" :key="category.categoryId"
									style="background:var(--grey-1);padding:5px;margin-bottom:5px;" @click="this.category = category"
									class="link flexcenter">
									<div>{{ category.name }}</div>
									<b style="flex-grow:1;">&nbsp;</b>

									<Icon fileName="w3_chevron_right_dark" style="width:8px;height:12px;margin-right:5px;" />

								</div>
							</div>

						</div>
					</div>
				</div>
				<hr />
			</div>

			<hr />

			<SelectCategoryWrapper  v-if="!this" style="border:5px solid red;padding:10px;"/>

			<hr />


			<!-- tillverkare -->
			<h3>Tillverkare</h3>
			<div class="flexcenter" style="align-items:stretch;">
				<div style="background:var(--grey-2);padding:10px;width:50%;">
					<b>Vald tillverkare</b><br />
					{{ this.manufactor ? this.manufactor.name : 'Ingen tillverkare' }}
					<br />
					Antal produkter: {{ productCountManufactor }}
				</div>

			</div>
			<hr />
			<select v-model="this.manufactor" @change="this.setupScroll()">
				<option value="">Välj tillverkare</option>
				<option v-for="(manufactor, index) in manufactorList" :key="index" :value="manufactor">{{
					manufactor.name }}</option>
			</select>

			<hr />


			<div class="flexcenter" v-if="!this">
				<div>
					<!-- välja tillverkare-knapp -->
					<div style="background:var(--grey-2);border:1px solid var(--grey-4);border-radius:5px;padding:10px;"
						@click="this.popoverManufactor = !this.popoverManufactor; this.setupScroll();">
						<div class="flexcenter link">


							<b>{{ this.manufactor ? 'Tillverkare' : 'Tillverkare (alla)' }} </b>
						</div>
						<div class="flexcenter" style="margin-top:3px;">
							<img src="@/assets/button_close_dark.png" v-if="this.manufactor" class="link"
								@click.stop="this.manufactor = null" style="height:15px;width:15px;margin-right:3px;" />
							<div>{{ this.manufactor ? this.manufactor.name : 'Välj tillverkare' }}</div>
							<b style="flex-grow:1;">&nbsp;</b>
							<Icon :fileName="this.popoverManufactor ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark'"
								style="width:12px;height:12px;margin-left:10px;" />
						</div>
					</div>

					<!-- tillverkare popover -->
					<div v-show="this.popoverManufactor"
						style="position:absolute;background:var(--grey-3);width:400px;height:400px;padding:10px;filter: drop-shadow(0px 2px 10px #777777);overscroll-behavior: contain;">



						<!-- lista tillverkare -->
						<div style="height:100%;">
							<div class="flexcenter">

								<h3>Tillverkare</h3>
								<b style="flex-grow:1;"></b>
								<img src="@/assets/button_close_dark.png" class="link" @click="this.popoverManufactor = false;"
									style="height:20px;width:20px;margin-right:5px;" />
							</div>

							<!-- sök tillverkare -->
							<div style="height:40px;margin-top:5px;">

								<div class="form textField" :title="'filter: ' + this.filterManufactor"
									style="height:30px;padding:0px;">
									<input type="text" placeholder="Value..." v-model="filterManufactor" />
									<img src="@/assets/w3_button_close_light.png" v-if="this.filterManufactor"
										@click="this.filterManufactor = ''" style="height:20px;width:20px;margin-right:5px;" />
								</div>


							</div>

							<!-- lista tillverkare-->
							<div ref="manufactorList" style="overflow:scroll;max-height:calc(100% - 100px);">

								<div v-for="(manufactor, index) in this.manufactorList" :key="index"
									:style="this.manufactor && this.manufactor.manufactorId == manufactor.manufactorId ? 'background:var(--grey-5);' : 'background:var(--grey-1);'"
									style="padding:5px;margin-bottom:5px;" class="link">

									<!-- klickbar kategori-->


									<div class="flexcenter" @click="this.manufactor = manufactor; this.popoverManufactor = false;"
										ref="manufactors" :id="'manufactor-' + manufactor.manufactorId">
										{{ manufactor.name }}



									</div>


								</div>
							</div>
						</div>


						<div v-if="!this.category && false" style="overflow:scroll;max-height:calc(100% - 100px);">
							<div style="padding:5px;margin-bottom:10px;">
								<b>Lista huvud-kategorier</b>
							</div>
							<div v-for="category in this.categoryPopover.categoryList" :key="category.categoryId"
								style="background:var(--grey-1);padding:5px;margin-bottom:5px;" @click="this.category = category"
								class="link flexcenter">
								<div>{{ category.name }}</div>
								<b style="flex-grow:1;">&nbsp;</b>

								<Icon fileName="w3_chevron_right_dark" style="width:8px;height:12px;margin-right:5px;" />

							</div>
						</div>

					</div>
				</div>
			</div>

			<hr />

			<SelectManufactorWrapper v-if="!this" />

		</div>



		<div style="height:600px;width:100px;"> </div>

	</div>
</template>
<script>
import listHelper from '../../helper/list-helper';
import { modelMixin } from '../../mixins/modelMixin';
import { STORE_GETTER } from '../../store/store';

import SelectManufactorWrapper from '@/components/product/search/SelectManufactorWrapper.vue';
import SelectCategoryWrapper from '@/components/product/search/SelectCategoryWrapper.vue';
import SelectMcWrapper from '@/components/product/search/SelectMcWrapper.vue';



export default {
	name: "TestSelectMcView",
	components: { SelectManufactorWrapper, SelectCategoryWrapper, SelectMcWrapper },
	mixins: [modelMixin],
	data() {
		return {
			brand: null,
			mc: null,
			year: null,
			popoverMc: false,
			filterBrand: null,
			filterMc: null,
			category: null,
			filterCategory: null,
			manufactor: null,
			popoverManufactor: false,
			filterManufactor: null,
			selectedCategoryInList: null,
			popoverCategory: false,
			showCategoryId: null


		};
	},
	watch: {
		brand: function (brand) {
			this.mc = null
			this.year = null
			console.log('FP: brand: ', brand);
			//this.setupScroll()
			this.filterMc = null

		},
		mc: function (mc) {
			this.year = null
			console.log('FP: mc: ', mc);
			//this.setupScroll()
		},
		year: function (year) {
			console.log('FP: year', year);
			//this.setupScroll()
		},
		popoverMc: function (popoverMc) {
			console.log('FP: popoverMc', popoverMc);


			setTimeout(() => {
				this.setupScroll()
			}, 500);


		},
		/*selectedCategoryInList: function (category) {
			console.log('FP: selectedCategoryInList: ', category);

			this.category = this.findInCategoryTree(category.categoryId);
		},*/

		category: function (category) {

			if (category == null) {
				this.selectedCategoryInList = null;

			} else {
				this.selectedCategoryInList = this.categoryList.find(c => c.categoryId == category.categoryId)
			}


		},

		popoverCategory: function (popoverCategory){
			console.log('FP: popoverCategory', popoverCategory);

			setTimeout(() => {
				this.setupScroll()
			}, 500);
		},

		popoverManufactor: function (popverManufactor){

			console.log('FP: popverManufactor', popverManufactor);

			setTimeout(() => {
				this.setupScroll()
			}, 500);
		}





	},

	computed: {

		categoryPopover() {

			if (this.category == null) {
				//return ({ name: "Kategorier", categoryList: this.categoryTree, parent: 0 });
				//return ({ name: "Kategorier", categoryList: this.categoryTree?.categoryList, parent: 0 }); // FP-CT
				return (this.categoryTree); // FP-CT
			}

			if (this.category && !this.category.categoryList) {

				//const category = this.findNode(this.category.parent, { categoryId: -1, categoryList: this.categoryTree });
				const category = this.findNode(this.category.parent, this.categoryTree); // FP-CT

				return category;
			}

			return this.category

		},

		mcList() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.mcList) {
				return baseModel.mcList
			}

			return null;

		},

		mcTree() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.mcTree) {
				return baseModel.mcTree
			}

			return null;

		},
		productCountMc() {

			if (this.year) {
				return this.year.productList.length
			}

			if (this.mc) {

				return this.mc.productListAll.length
			}

			return "--";
		},

		productCountCategory() {

			if (this.category) {
				return "---";
			}



			return "--";
		},
		/*manufactorList(){
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];

			if (baseModel && baseModel.manufactorList){

				if (this.filterManufactor == null || this.filterManufactor == ""){
					return baseModel.manufactorList
				}

				const list = baseModel.manufactorList.filter( manufactor => {

					console.log('FP: manufactor, ', manufactor);

					//return false;
					// manufactor.search 
					return listHelper.filter(manufactor.name, this.filterManufactor)

				})

				return list;
				
			}

			return null;
		},*/

		manufactorList(){
			const manufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST];

			if (manufactorList){

				if (this.filterManufactor == null || this.filterManufactor == ""){
					return manufactorList
				}

				const list = manufactorList.filter( manufactor => {

					console.log('FP: manufactor, ', manufactor);

					//return false;
					// manufactor.search 
					return listHelper.filter(manufactor.name, this.filterManufactor)

				})

				return list;
				
			}

			return null;
		},

		productCountManufactor(){
			return "xxx";
		},

		isFilterCategoryEmpty(){
			return this.filterCategory == null || this.filterCategory == ""
		},
		/*categoryList() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.categoryModel && baseModel.categoryModel.categoryList) {
				return baseModel.categoryModel.categoryList
			}

			return null;
		},*/
		categoryList() {

			const categoryModel = this.$store.getters[STORE_GETTER.CATEGORY_MODEL]

			if (categoryModel && categoryModel.categoryList) {
				return categoryModel.categoryList
			}

			return null;
		},

		filteredCategoryList() {
			const categoryModel = this.$store.getters[STORE_GETTER.CATEGORY_MODEL]

			if (categoryModel && categoryModel.categoryList) {

				const list = listHelper.filterList(categoryModel.categoryList, this.filterCategory);

				return list;
			}

			return null;
		},

		/*filteredCategoryList(){
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.categoryModel && baseModel.categoryModel.categoryList) {

				const list = listHelper.filterList(baseModel.categoryModel.categoryList, this.filterCategory);

				return list;
			}

			return null;
		},*/

		categoryTree() {

			const categoryModel = this.$store.getters[STORE_GETTER.CATEGORY_MODEL]

			if (categoryModel && categoryModel.categoryTree) {
				return categoryModel.categoryTree
			}

			return null;
		},

		/*categoryTree() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.categoryModel && baseModel.categoryModel.categoryTree) {
				return baseModel.categoryModel.categoryTree
			}

			return null;
		},*/

		categoryPath() {

			var list = [];

			/*if (!this.category) {
				list.push({ name: "Kategorier", categoryList: this.categoryTree });
				return list;
			}*/

			//list.push({ name: "Kategorier", categoryList: this.categoryTree, categoryId: -1 }); // FP-CT ?
			//list.push({ name: "Kategorier", categoryList: this.categoryTree?.categoryList, categoryId: -1 }); // FP-CT
			list.push(this.categoryTree); // FP-CT	

			if (!this.category) {
				return list;
			}

			if (this.category.pathIdList == null) {
				alert("PathIdList is null, ")
				return;
			}
			
			const pathIdList = this.category.pathIdList?.split(";");
			//const pathIdList = this.category.pathIdList

			//var currentCategoryNode = this.categoryTree.find(category => category.categoryId == pathIdList[0])
			var currentCategoryNode = this.categoryTree.categoryList?.find(category => category.categoryId == pathIdList[0]) // FP-CT

			if (currentCategoryNode) {
				list.push(currentCategoryNode);
			} else {
				return list;
			}



			console.log('FP: pathIdList: ', pathIdList);
			console.log('FP: currentCategoryNode: ', currentCategoryNode);
			console.log('FP: thisCategory: ', this.category);

			// loopa path

			for (var i = 1; i < pathIdList.length; i++) { // loopa alla i path, börja inte på första. 

				currentCategoryNode = currentCategoryNode.categoryList.find(category => category.categoryId == pathIdList[i])

				//console.log('FP: currentCategoryNodeName: ', currentCategoryNode.name);

				list.push(currentCategoryNode)

			}






			return list;

		},





	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });

		setupScroll() {

			if (this.brand && this.$refs.brands) {
				const brandDiv = this.$refs.brands.find(brand => brand.id == "brand-" + this.brand.id);
				if (brandDiv) {
					brandDiv.scrollIntoView({ block: "nearest", inline: "nearest" });
				}
			} else if (this.$refs.brandList) {
				this.$refs.brandList.scrollTop = 0;
			}

			if (this.mc) {
				const mcDiv = this.$refs.mcs.find(mc => mc.id == "mc-" + this.mc.mcId);
				if (mcDiv) {
					mcDiv.scrollIntoView({ block: "nearest", inline: "nearest" })
				}
			} else if (this.$refs.mcList){
				this.$refs.mcList.scrollTop = 0;
			}


			if (this.manufactor && this.$refs.manufactors){
				console.log('FP: refs.manufactors: ', this.$refs.manufactors);
				
				const manufactorDiv = this.$refs.manufactors.find(manufactorDiv => manufactorDiv.id == "manufactor-" + this.manufactor.manufactorId)
				if (manufactorDiv){
					manufactorDiv.scrollIntoView({block: "nearest", inline: "nearest"})
				}

			} else if (this.$refs.manufactorList){
				this.$refs.manufactorList.scrollTop = 0;
			}

			if (this.category && this.$refs.categoryListRef){

				//alert("cid:" + this.category.categoryId)

				const categoryDiv = this.$refs.categoryListRef.find(categoryDiv => categoryDiv.id == "category-" + this.category.categoryId)

				if (categoryDiv){
					categoryDiv.scrollIntoView({ block: "nearest", inline: "nearest" })
				}

			} else if (this.$refs.categoryListRef){
				this.$refs.categoryListRef.scrollTop = 0;
			}

		},

		filterBrandList(brandList) {

			if (this.filterBrand == null || this.filterBrand == "") {
				return brandList;
			}

			const list = brandList.filter(brand => {

				return (brand && this.format(brand.name).includes(this.format(this.filterBrand)))

			});

			return list;

		},

		format(string) {

			return string.toLowerCase().replace(" ", "").replace("-", "");

		},

		filterMcList(mcList) {

			if (this.filterMc == null || this.filterMc == "") {
				return mcList;
			}

			const list = mcList.filter(mc => {

				return (mc && this.format(mc.modelName).includes(this.format(this.filterMc)))
			});

			return list;

		},
		selectBrand(brandId) {

			const brand = this.mcTree.find(brand => brand.id == brandId)

			this.brand = brand

		},
		selectCategory(categoryId) {
			/*const category = this.categoryList.find(category => category.categoryId == categoryId);

			if (category) {
				alert(category.name);
			}

			alert(categoryId);*/

			if (categoryId == 3) {
				this.category = null;
				return;
			}

			const category = this.findInCategoryTree(categoryId);
			//const category = this.findNode2(categoryId);

			if (category) {
				this.category = category
			}

			console.log('FP: category:', category);

		},



		findNode2(categoryId) {
			const category = this.categoryList.find(category => category.categoryId == categoryId)

			if (category) {
				console.log('FP: hittade category:', category);

				return category
			}

			alert("Hittade inte kategori med categoryId: " + categoryId)
		},
		findInCategoryTree(categoryId) {
			//return this.findNode(categoryId, { categoryId: -1, categoryList: this.categoryTree });
			return this.findNode(categoryId, this.categoryTree); // FP-CT


		},
		findNode(categoryId, currentNode) {

			//console.log('FP: findNode: categoryId: ', currentNode.categoryId);

			var i,
				currentChild,
				result;

			if (categoryId == currentNode.categoryId) {
				return currentNode;
			} else {

				// Use a for loop instead of forEach to avoid nested functions
				// Otherwise "return" will not work properly
				if (currentNode.categoryList) {

					for (i = 0; i < currentNode.categoryList.length; i += 1) {

						currentChild = currentNode.categoryList[i];

						// Search in the current child
						result = this.findNode(categoryId, currentChild);

						// Return the result if the node has been found
						if (result !== false) {
							return result;
						}
					}
				}

				// The node has not been found and we have no more options
				return false;
			}
		},
		categoryPathLabel(categoryPath) {

			var label = "";

			for (var i = 0; i < categoryPath.length - 1; i++) {
				label = label + categoryPath[i].name;

				if (i < categoryPath.length - 2) {
					label = label + "/";
				}
			}



			return label;
		},
		changedX() {
			console.log('FP: changeX: ', this.selectedCategoryInList);

			if (this.selectedCategoryInList && this.selectedCategoryInList.categoryId) {
				this.category = this.findInCategoryTree(this.selectedCategoryInList.categoryId)
			} else {
				this.category = null;
			}

			//this.category = this.findInCategoryTree(category.categoryId);
			//alert("category: " + this.selectedCategoryInList.categoryId)
		}


	},
	created() {
		this.getBaseModel()
	}
};
</script>

<style scoped>
div.brandBox {
	display: flex;
	background: var(--grey-dark-4);
	border-radius: 5px;
	align-items: flex-start;

}

div.brandBox img {
	padding: 5px;
	height: auto;
	width: 52px;
}

div.categoryArrow img.link {
	opacity: 0.2;
}

div.categoryArrow:hover img.link {
	opacity: 0.9;
}

div.breadcrumbs div.childCategoryList div.badge {
	background: var(--grey-4);
	color: var(--grey-dark-2);
}
</style>